webpackJsonp([36],{

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'QuantityInput';
var CLS = 'quantityInput';
var WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/quantityInput.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


var QuantityInput = exports.QuantityInput = function () {
	function QuantityInput($el) {
		_classCallCheck(this, QuantityInput);

		// $el is the widget node return by the loadQuantityInput function
		this.$el = $el;
	}

	_createClass(QuantityInput, [{
		key: 'init',
		value: function init() {
			this.setQuantityInput();
		}
	}, {
		key: 'setQuantityInput',
		value: function setQuantityInput() {
			// Add Some logic here
			var $wg = $(this.$el);
			var $btns = $wg.find('.btn-up, .btn-down');
			var $input = $wg.find('input');
			var max = $input.attr('max');

			$input.on('keypress', function (e) {
				var code = e.keyCode || e.which;

				// prevent (. , + - e)
				if (code == 46 || code == 44 || code == 43 || code == 45 || code == 101) {
					e.preventDefault();
					return;
				}
			});

			$input.on('input', function () {
				var newValue = $input.val();

				// prevent values higher than the max
				if (max) {
					if (parseInt(newValue) > parseInt(max)) {
						$input.val(max);
						return;
					}
				}
			});

			$btns.on('click', function () {
				if ($(this).hasClass('btn-up')) {
					var next = parseInt($input.val()) + 1;

					if (max) {
						if (next > parseInt(max)) return;
					}

					$input.val(next);
				} else {
					if (parseInt($input.val()) > 1) {
						$input.val(parseInt($input.val()) - 1);
					}
				}
			});
		}

		// Add more functions like on above here

	}]);

	return QuantityInput;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ })

});


// WEBPACK FOOTER //
// wg-quantity-input-chunk.js